import { faChevronRight, faXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Flex, IconButton } from '@modusign/design-system';
import { iconNeutralSlightlyLight } from '@modusign/design-system/colors';

import Step from '@app/components/Step';

interface InvitationHeaderProps {
  currentStep: 'INFO' | 'CAUTION';
  onClose: () => void;
}

export default function InvitationHeader({ currentStep, onClose }: InvitationHeaderProps) {
  return (
    <Flex alignItems="center" flexDirection="row" justifyContent="space-between" width="100%">
      <Flex alignItems="center" gap={2} justifyContent="flex-start">
        <Step variant={currentStep === 'INFO' ? 'active' : 'done'}>1</Step>
        <FontAwesomeIcon color={iconNeutralSlightlyLight} icon={faChevronRight} />
        <Step variant={currentStep === 'CAUTION' ? 'active' : 'todo'}>2</Step>
      </Flex>
      <IconButton
        color="textNeutralLight"
        sx={{
          borderRadius: '3px',
          width: '30px',
          height: '30px',
          '&:hover': {
            bg: 'buttonBackgroundNeutralSlightlyDark',
            '& > svg': {
              color: 'textNeutralDark',
            },
          },
        }}
        onClick={onClose}
      >
        <Box as={FontAwesomeIcon} height="18px" icon={faXmark} width="12px" />
      </IconButton>
    </Flex>
  );
}
